import { SwiperOptions } from "swiper/types";

export const partnersSliderConfig: SwiperOptions = {
    mousewheel: true,
    spaceBetween: 24,
    slidesPerView: "auto",
    freeMode: true,
};
